import { render } from "./ProjectSummaryPostCrowdfunding.vue?vue&type=template&id=9363b6d0"
import script from "./ProjectSummaryPostCrowdfunding.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryPostCrowdfunding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__